import React, { useRef, useState } from 'react'
import { Popover } from "react-tiny-popover";
import { AudioIcon, CloseIcon, GifIcon, PictureIcon, PlusIcon, VideoIcon } from '../../../assets/icons';
import InputTextArea from '../../../utils/components/InputTextArea/InputTextArea';
import useModal from '../../../utils/hooks/useModal';

import ModalAudioPost from '../../ModalAudioPost';
import ModalGif from '../..//ModalGif';
import './CommentNew.css'


const CommentNew = ({
    dataFile, setDataFile,
    sendComment = () => { },
    setComment = () => { },
    isReplyComment,
    placeholder,
    comment,
}) => {

    const fileRef = useRef(null);
    const [isShowAudio, setIsShowAudio] = useState(false)
    const [isOnlyGif, setIsOnlyGif] = useState(null);
    const [urlFile, setUrlFile] = useState(null)
    const [isOnlyAudio, setIsOnlyAudio] = useState(null)

    const [isShowGif, setIsShowGif] = useState(false)
    const [refOpt, isShowOpt, setIsShowOpt] = useModal(false)
    const selectAudio = (e) => {
        e.stopPropagation()
        setIsShowGif(false)
        setIsShowAudio(!isShowAudio)
    }
    const selectGif = (e) => {
        e.stopPropagation()
        setIsShowAudio(false)
        setIsShowGif(!isShowGif)
    }

    const onFileChange = (e) => {
        if (e.target.files[0]) {
            setDataFile({
                [e.target.files[0].name]: {
                    file: e.target.files[0],
                    url: URL.createObjectURL(e.target.files[0])
                }

            })
        }
    }
    return (
        <div style={{

            width: '90%'
        }} className='m-5'>
            <div className={`input-comment-post ${isReplyComment ? 'reply' : ''}`}>

                <InputTextArea
                    setValue={value => setComment(value)}
                    onSend={sendComment}
                    placeholder={placeholder}
                    name='comment'
                    value={comment}
                />


                {Object.values(dataFile).length > 0 && <div className=" xscroll-menu">
                    {Object.values(dataFile).map(data => {
                        var viewData = <div></div>
                        if (data.file.type.includes('image'))
                            viewData =
                                <img alt="img" className='img-multimedia-message' src={data.url} />
                        if (data.file.type.includes('video'))
                            viewData =
                                <video preload="auto" className="video-post-view" controls>
                                    <source src={data.url}></source>
                                </video>
                        if (data.file.type.includes('audio'))
                            viewData =
                                <div className='parent-width'>
                                    <audio preload="auto" controlsList="nofullscreen nodownload noremoteplayback" controls>
                                        <source src={data.file.url}></source>
                                    </audio>
                                </div>
                        return (
                            <div className="relative parent-width column centerContent centerItems" >
                                {viewData}
                                <div onClick={() => {
                                    setDataFile([])
                                }} className="close-modal-post">
                                    <CloseIcon className="cls-1" height="13" width="13" />
                                </div>
                            </div>
                        )
                    })
                    }
                </div>}




                <div className='items-message-icon'>

                    <Popover
                        containerStyle={
                            {
                                zIndex: 3000
                            }
                        }
                        onClickOutside={() => setIsShowOpt(false)}
                        isOpen={isShowOpt}
                        reposition={true}
                        positions={['top']} // preferred positions by priority
                        content={({ position, childRect, popoverRect }) => (
                            <OptionsModal setIsShowOpt={setIsShowOpt} displayModal={isShowOpt}
                                selectAudio={selectAudio}
                                selectGif={selectGif}
                                fileRef={fileRef}
                            />
                        )}
                    >
                        <div onClick={() => {
                            setIsShowOpt(true)
                        }}>
                            <PlusIcon className='icon-options-message' height="20" />
                        </div >

                    </Popover>
                    {/*   <div onClick={() => {
                        setIsShowOpt(true)
                    }}>
                        <PlusIcon className='icon-options-message' height="20" />
                    </div >
*/}
                    <div>

                        <input ref={fileRef} type="file" onChange={(event) => {

                            onFileChange(event)
                            fileRef.current.value = null
                        }} />
                        <ModalAudioPost
                            setOnlyAudio={setIsOnlyAudio}
                            setData={setDataFile}
                            displayModal={isShowAudio}
                            closeModal={selectAudio}
                        />
                        <ModalGif
                            setOnlygif={setIsOnlyGif}
                            setData={setDataFile}
                            displayModal={isShowGif}
                            closeModal={selectGif}
                        />
                    </div>



                </div>



            </div>
        </div>
    )
}

const OptionsModal = ({ fileRef, selectAudio, selectGif, displayModal, setIsShowOpt }) => {
    const divStyle = {
        display: displayModal ? 'block' : 'none'
    }
    return (
        <div style={divStyle}>
            <div className="content-options-message-container">
                <div className='content-options-message-icons'>
                    <div onClick={(e) => {
                        //if (!isLinkGifOrStiker)
                        selectAudio(e)
                    }}>
                        <AudioIcon className='icon-options-message' height="20" />
                    </div>
                    <div onClick={(e) => {
                        //if (!isLinkGifOrStiker)
                        // selectAudio(e)
                        fileRef.current.accept = "video/*";
                        fileRef.current.click()
                    }}>
                        <VideoIcon className='icon-options-message' height="20" />
                    </div>
                    <div onClick={(e) => {
                        //if (!isLinkGifOrStiker)
                        //  selectAudio(e)
                        fileRef.current.accept = "image/*";
                        fileRef.current.click()
                    }}>
                        <PictureIcon className='icon-options-message' height="20" onClick={(e) => {
                            //if (!isLinkGifOrStiker)
                            //  selectAudio(e)
                        }} />
                    </div>
                    <div onClick={(e) => {
                        //if (!isLinkGifOrStiker)
                        //  selectAudio(e)
                        selectGif(e)
                    }}>
                        <GifIcon className='icon-options-message' height="20" onClick={(e) => {
                            // if (!isLinkGifOrStiker)
                            //      selectAudio(e)
                        }} />
                    </div>
                </div>


            </div>
        </div>
    )
}
export default CommentNew
